exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "mat-input-container {\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sofia/Documents/ng2-portals/ng2-firebase-toolkit-admin/src/app/common/formly/types/rich-text-editor/ckeditor.dialog.scss
// module id = ../../../../../src/app/common/formly/types/rich-text-editor/ckeditor.dialog.scss
// module chunks = main